import { MapPin, Navigation } from "lucide-react";

export function Parties({ lr, pickups, deliveries, navigate }) {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-white border border-[#E5E3DB] p-4">
          <div className="section-title flex items-center gap-2"><MapPin className="w-4 h-4" /> Pickup Location(s)</div>
          {pickups.length > 0 ? (
            <div className="divide-y divide-[#F0EDE5]">
              {pickups.map((p, i) => (
                <div key={i} className="py-2" data-testid={`lr-detail-pickup-${i}`}>
                  <button className="font-medium hover:underline" onClick={() => p.company && navigate(`/entity/customer/${encodeURIComponent(p.company)}`)}>{p.company || "—"}</button>
                  <div className="text-sm text-[#68665E]">{p.address}</div>
                  {p.gst && <div className="text-xs font-mono text-[#68665E]">GST: {p.gst}</div>}
                  {(p.poc_name || p.poc_phone) && <div className="text-xs text-[#68665E] mt-0.5">POC: {p.poc_name} {p.poc_phone ? `· ${p.poc_phone}` : ""}</div>}
                </div>
              ))}
            </div>
          ) : (
            <div data-testid="lr-detail-consignor">
              <button className="font-medium hover:underline" onClick={() => navigate(`/entity/customer/${encodeURIComponent(lr.consignor_name)}`)}>{lr.consignor_name || "—"}</button>
              <div className="text-sm text-[#68665E]">{lr.consignor_address}</div>
              <div className="text-xs font-mono text-[#68665E] mt-1">GST: {lr.consignor_gst || "—"}</div>
            </div>
          )}
        </div>
        <div className="bg-white border border-[#E5E3DB] p-4">
          <div className="section-title flex items-center gap-2"><MapPin className="w-4 h-4" /> Delivery Location(s)</div>
          {deliveries.length > 0 ? (
            <div className="divide-y divide-[#F0EDE5]">
              {deliveries.map((d, i) => (
                <div key={i} className="py-2" data-testid={`lr-detail-delivery-${i}`}>
                  <button className="font-medium hover:underline" onClick={() => d.company && navigate(`/entity/customer/${encodeURIComponent(d.company)}`)}>{d.company || "—"}</button>
                  <div className="text-sm text-[#68665E]">{d.address}</div>
                  {d.gst && <div className="text-xs font-mono text-[#68665E]">GST: {d.gst}</div>}
                  {(d.poc_name || d.poc_phone) && <div className="text-xs text-[#68665E] mt-0.5">POC: {d.poc_name} {d.poc_phone ? `· ${d.poc_phone}` : ""}</div>}
                </div>
              ))}
            </div>
          ) : (
            <div data-testid="lr-detail-consignee">
              <button className="font-medium hover:underline" onClick={() => navigate(`/entity/customer/${encodeURIComponent(lr.consignee_name)}`)}>{lr.consignee_name || "—"}</button>
              <div className="text-sm text-[#68665E]">{lr.consignee_address}</div>
              <div className="text-xs font-mono text-[#68665E] mt-1">GST: {lr.consignee_gst || "—"}</div>
            </div>
          )}
        </div>
      </div>

      {(() => {
        const origin = (pickups[0]?.address || lr.consignor_address || lr.from_location || "").trim();
        const dest = (deliveries[deliveries.length - 1]?.address || lr.consignee_address || lr.to_location || "").trim();
        if (!origin && !dest) return null;
        const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(dest)}&travelmode=driving`;
        return (
          <a href={url} target="_blank" rel="noopener noreferrer" className="btn-secondary inline-flex items-center gap-2 mb-6" data-testid="lr-detail-directions">
            <Navigation className="w-4 h-4" /> Get Route Directions (Pickup -&gt; Delivery)
          </a>
        );
      })()}
    </>
  );
}
